import { useSearchParams } from "react-router-dom"
import { NavBarSiteSearchParamsValues } from "../../../components/NavBarSite/_v1/Index"

export const GLOBAL_LINKS_ORIGIN = window.location.origin
//export const GLOBAL_LINKS_ORIGIN = 'https://tonomercado.com.br'
//export const GLOBAL_LINKS_ORIGIN = 'http://localhost:3000'
export const GLOBAL_LINKS_BAIXAR_APP = `${GLOBAL_LINKS_ORIGIN}/baixar_app/`

export const GLOBAL_LINKS_BAIXAR_ANDROID = `https://play.google.com/store/apps/details?id=br.com.tonomercado`
export const GLOBAL_LINKS_TOOME_MAPS_ADDRESS = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1077.3706442270625!2d-53.76535238536561!3d-24.73276910768728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f3957e5807c763%3A0xb7f5416d6ecad22!2sTooMe%20-%20T%C3%B4%20no%20mercado!5e0!3m2!1spt-BR!2sbr!4v1745351998587!5m2!1spt-BR!2sbr`

export const GLOBAL_LINKS_WEB_APP = `/app/`;

//session
export const GLOBAL_LINKS_CADASTRE_ENTRAR = `${GLOBAL_LINKS_WEB_APP}#/session/login/`
export const GLOBAL_LINKS_CADASTRE_SE = `${GLOBAL_LINKS_WEB_APP}#/session/login/?new_member=1`

//settings
export const GLOBAL_LINKS_USER_SETTINGS = `${GLOBAL_LINKS_WEB_APP}#/opc_gerais`
//features
export const GLOBAL_LINKS_FEATURE_LISTA_INTELIGENTE = `${GLOBAL_LINKS_WEB_APP}#/SmartListHome`
export const GLOBAL_LINKS_FEATURE_MAPA_MERCADO = `${GLOBAL_LINKS_WEB_APP}#/mapa_mercado`
export const GLOBAL_LINKS_FEATURE_JOGOS_E_BENEFICIOS = `${GLOBAL_LINKS_WEB_APP}#/pointsGame`

export const GLOBAL_CITY_ID = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentCityId = searchParams.get(NavBarSiteSearchParamsValues.city_id) || 1;
    return currentCityId;
}

export const GLOBAL_LINKS_IFRAME_ENCATES = () => {
    return `${GLOBAL_LINKS_WEB_APP}#/encartes?city_id=${GLOBAL_CITY_ID()}`
}
export const GLOBAL_LINKS_IFRAME_MURAL = () => {
    return `${GLOBAL_LINKS_WEB_APP}#/PromoHubView?hubType=MURAL&localId=${GLOBAL_CITY_ID()}&hiddenComments=1&isIframe=1`
}

export const GLOBAL_TOOME_SEARCH = (query) => {
    return `${GLOBAL_LINKS_WEB_APP}#/product_search?inputFocus=0&filterQuery=${query}`;
}
